import { mapValues } from "lodash"

/**
 * Condenses the per item pricing kept on window.customerPrices for the order/quote "create" event.
 * The raw values carry every price source loaded for the item (customerPrices), which made these
 * events several KB each; the chosen price and where it came from is all that's needed to review a
 * price later.
 */
export function summariseCustomerPrices(prices: Record<string, any> | undefined) {
  return mapValues(prices ?? {}, pricing => ({
    sourceName: pricing?.sourceName,
    sourceType: pricing?.sourceType,
    customerPrice: pricing?.customerPrice,
    customerPriceDiscountPercent: pricing?.customerPriceDiscountPercent,
    usingNonStandardPrice: pricing?.usingNonStandardPrice,
    standardPrice: pricing?.standardPrice,
    currency_name: pricing?.currency_name,
    sourceCount: Array.isArray(pricing?.customerPrices) ? pricing.customerPrices.length : undefined,
  }))
}
